import { ProfileLayout } from "@app/layouts/profile-layout";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profile")({
	component: () => <ProfileLayout />,
	beforeLoad: async ({ location }) => {
		const isLoginPage = location.pathname === "/profile";

		if (isLoginPage) {
			throw redirect({ to: "/profile/general" });
		}
	},
	staticData: {
		breadcrumbId: "page.profile.profile.title",
		breadcrumbTitle: "Profile",
	},
});
